<script lang="ts">
	import Layout from "./Layout/Layout.svelte";
	import { Router } from "svelte-navigator";
	import { isDarkMode } from "./store";
	import LayoutRouter from "./Routes/LayoutRoutes.svelte";
	import { onMount } from "svelte";
	import PreLodaer from "./Layout/PreLoader/PreLodaer.svelte";
    import AuthRouter from "./Routes/AuthRouter.svelte";
	import AuthRotes from "./Routes/AuthRoutes"
	var isAuthRoute:boolean = false;
	let darkMode: boolean;
	let ispreloader: boolean = false;
	isDarkMode.subscribe((value: boolean) => {
		darkMode = value;
	});
	$: darkMode ? document.body.classList.add("dark-only") : document.body.classList.remove("dark-only");
	onMount(() => {
		setTimeout(() => {
			ispreloader = true;
		}, 1000);
	});
	$: AuthRotes.map((item) => {
        if (item.path === window.location.pathname){
        isAuthRoute = true;
        return false;
      }
    });
</script>

{#if !ispreloader}
	<PreLodaer />
{/if}
<div id="root">
	<div class="App">
		<Router>
			{#if !isAuthRoute}
				<Layout>
					<LayoutRouter />
				</Layout>
			{:else}
				<AuthRouter />
			{/if}
		</Router>
	</div>
</div>

<style lang="scss" global>
	@import "./global.scss";
</style>
